import React, {ReactNode} from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {Button, FormControl, TextField, Typography} from "@material-ui/core";
import axios from "axios";
import config from "../../../config.json";
import {userService} from "../../../services/UserService";
import {INotificacion, IParcela} from "../../../types";
import {Visibility, VisibilityOff} from "@material-ui/icons";

const texts = require('../../../texts/configuracion.json');


interface IProps {
    notify(notification: INotificacion): void
    idioma: string
}

interface IState {
    real_pass: string,
    pass: string,
    new_pass: string,
    confirm: string,
    view1: boolean,
    view2: boolean,
    view3: boolean,
    hover: string,
    error_pass: string
    error_new_pass: string
    text: Record<string, string>
}

class MobileCambiarContra extends React.Component<IProps, IState> {
    state: IState = {
        real_pass: '',
        pass: '',
        new_pass: '',
        confirm: '',
        view1: false,
        view2: false,
        view3: false,
        hover: '',
        error_pass: '',
        error_new_pass: '',
        text: texts[this.props.idioma]
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    componentDidMount() {
        axios.get(
            config.url+'/get/usuario',
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res: { data: Record<string, number|string|null>}) => {
                this.setState({
                    real_pass: res.data['pass'] as string
                })
            })
            .catch(() => {})
    }

    modificado = (): boolean => {
        return this.state.new_pass.length > 0 && this.state.new_pass === this.state.confirm;
    }

    handleClick = () => {
        if (this.state.pass !== this.state.real_pass) {
            this.setState({error_pass: this.state.text["12"]})
            return
        }

        if (this.state.new_pass.length < 6) {
            this.setState({error_new_pass: this.state.text["13"]})
            return
        }
        if (this.state.new_pass.toLowerCase() === this.state.new_pass) {
            this.setState({error_new_pass: this.state.text["14"]})
            return
        }
        if (!/\d/.test(this.state.new_pass)) {
            this.setState({error_new_pass: this.state.text["15"]})
            return
        }

        axios.post(
            config.url+'/modificar/usuario',
            {pass: this.state.new_pass},
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }
            })
            .then(() => {
                this.setState({
                    real_pass: this.state.new_pass,
                    pass: '',
                    new_pass: '',
                    confirm: ''
                })
                this.props.notify({message: this.state.text["16"], variant: 'success'})
                setTimeout(() => userService.logout(), 2000)
            })
            .catch(() => {
                this.props.notify({message: this.state.text["17"], variant: 'error'})
            })
    }

    render () {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignSelf: "start",
                    height: '100%',
                    width: '100%',
                    marginLeft: 20
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <Typography
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        width: '100%',
                        fontWeight: "bold",
                        color: "#4C494B",
                        fontFamily: "Poppins",
                        marginTop: 20
                    }}
                >
                    {this.state.text["18"]}
                </Typography>

                <FormControl
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        width: '100%'
                    }}
                >
                    <TextField
                        style={{
                            marginTop: 20,
                            width: '80%',
                            fontFamily: "Poppins"
                        }}
                        inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                        InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                        value={this.state.pass}
                        onChange={e => this.setState({pass: e.target.value})}
                        label={this.state.error_pass.length === 0? this.state.text["19"] : this.state.error_pass}
                        type={this.state.view1? 'text' : 'password'}
                    />
                    {this.state.view1?
                        <Visibility
                            style={{
                                width: 30,
                                height: 30,
                                cursor: "pointer",
                                color: this.state.hover === 'vis1'? "black" : '#4C494B',
                                marginLeft: -30,
                                marginBottom: -50,
                                zIndex: 10
                            }}
                            onMouseEnter={() => this.setState({hover: 'vis1'})}
                            onMouseLeave={() => this.setState({hover: ''})}
                            onClick={() => {this.setState({view1: false})}}
                        />
                        :
                        <VisibilityOff
                            style={{
                                width: 30,
                                height: 30,
                                cursor: "pointer",
                                color: this.state.hover === 'vis1'? "black" : '#4C494B',
                                marginLeft: -30,
                                marginBottom: -50,
                                zIndex: 10
                            }}
                            onMouseEnter={() => this.setState({hover: 'vis1'})}
                            onMouseLeave={() => this.setState({hover: ''})}
                            onClick={() => {this.setState({view1: true})}}
                        />
                    }
                </FormControl>

                <FormControl
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        width: '100%'
                    }}
                >
                    <TextField
                        style={{
                            marginTop: 20,
                            width: '80%',
                            fontFamily: "Poppins"
                        }}
                        inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                        InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                        value={this.state.new_pass}
                        onChange={e => this.setState({new_pass: e.target.value})}
                        label={this.state.error_new_pass.length === 0? this.state.text["20"] : this.state.error_new_pass}
                        type={this.state.view2? 'text' : 'password'}
                    />
                    {this.state.view2?
                        <Visibility
                            style={{
                                width: 30,
                                height: 30,
                                cursor: "pointer",
                                color: this.state.hover === 'vis2'? "black" : '#4C494B',
                                marginLeft: -30,
                                marginBottom: -30,
                                zIndex: 10
                            }}
                            onMouseEnter={() => this.setState({hover: 'vis2'})}
                            onMouseLeave={() => this.setState({hover: ''})}
                            onClick={() => {this.setState({view2: false})}}
                        />
                        :
                        <VisibilityOff
                            style={{
                                width: 30,
                                height: 30,
                                cursor: "pointer",
                                color: this.state.hover === 'vis2'? "black" : '#4C494B',
                                marginLeft: -30,
                                marginBottom: -30,
                                zIndex: 10
                            }}
                            onMouseEnter={() => this.setState({hover: 'vis2'})}
                            onMouseLeave={() => this.setState({hover: ''})}
                            onClick={() => {this.setState({view2: true})}}
                        />
                    }
                </FormControl>


                <FormControl
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        width: '100%'
                    }}
                >
                    <TextField
                        style={{
                            marginTop: 20,
                            width: '80%',
                            fontFamily: "Poppins"
                        }}
                        inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                        InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                        value={this.state.confirm}
                        onChange={e => this.setState({confirm: e.target.value})}
                        label={this.state.text["21"]}
                        error={this.state.new_pass !== this.state.confirm}
                        type={this.state.view3? 'text' : 'password'}
                    />
                    {this.state.view3?
                        <Visibility
                            style={{
                                width: 30,
                                height: 30,
                                cursor: "pointer",
                                color: this.state.hover === 'vis3'? "black" : '#4C494B',
                                marginLeft: -30,
                                marginBottom: -30,
                                zIndex: 10
                            }}
                            onMouseEnter={() => this.setState({hover: 'vis3'})}
                            onMouseLeave={() => this.setState({hover: ''})}
                            onClick={() => {this.setState({view3: false})}}
                        />
                        :
                        <VisibilityOff
                            style={{
                                width: 30,
                                height: 30,
                                cursor: "pointer",
                                color: this.state.hover === 'vis3'? "black" : '#4C494B',
                                marginLeft: -30,
                                marginBottom: -30,
                                zIndex: 10
                            }}
                            onMouseEnter={() => this.setState({hover: 'vis3'})}
                            onMouseLeave={() => this.setState({hover: ''})}
                            onClick={() => {this.setState({view3: true})}}
                        />
                    }
                </FormControl>


                <Button
                    style={{
                        textTransform: "none",
                        width: "fit-content",
                        marginTop: 40,
                        backgroundColor: this.modificado()? '#80ED99': '#ccc',
                        borderRadius: 10,
                        marginBottom: 30
                    }}
                    disabled={!this.modificado()}
                    onClick={() => this.handleClick()}
                >

                    <Typography
                        style={{
                            fontSize: 24,
                            fontWeight: "bold",
                            fontFamily: "Poppins"
                        }}
                    >
                        {this.state.text["11"]}
                    </Typography>

                </Button>

            </div>
        )
    }

}


const mapStateToProps = (state: IStore) => ({
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileCambiarContra);
